module.exports = __webpack_public_path__ + "img/takeout-img2.5677a455.png";